import type { HTMLAttributes } from 'react';
import type { MotionProps } from 'framer-motion';

import { m } from 'framer-motion';
import { twMerge } from 'tailwind-merge';

import { varContainer } from './variants';

// ----------------------------------------------------------------------

export type MotionContainerProps = HTMLAttributes<HTMLDivElement> &
  MotionProps & {
    animate?: boolean;
    action?: boolean;
    className?: string;
  };

export function MotionContainer({
  className,
  animate,
  children,
  action = false,
  ...other
}: MotionContainerProps) {
  return (
    <m.div
      className={twMerge(className)}
      variants={varContainer()}
      initial={action ? false : 'initial'}
      animate={action ? (animate ? 'animate' : 'exit') : 'animate'}
      exit={action ? undefined : 'exit'}
      {...other}
    >
      {children}
    </m.div>
  );
}
